module.exports = __webpack_public_path__ + "media/乐器演奏-二胡与其他乐器.6fe4ef39.wav";